import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonStandaloneModule } from '../../common-standalone.module';

@Component({
  selector: 'app-chip-filters',
  standalone: true,
  imports: [CommonStandaloneModule],
  templateUrl: './chip-filters.component.html',
  styleUrls: ['./chip-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipFiltersComponent {
  @Input() layoutGap = '12px';
}
